export { ListOfPortals } from './ui/list-of-portals-element';
